import { render } from "./ExchangeStatsView.vue?vue&type=template&id=21629033"
import script from "./ExchangeStatsView.vue?vue&type=script&lang=js"
export * from "./ExchangeStatsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__